export default class HowWeWorkContent {
  name = 'how-we-work-page'
  slug = 'how-we-work'
  title = `${this.name}.title`
  subtitle = `${this.name}.subtitle`
  image = `${this.name}.image`
  imageMobile = `${this.name}.image-mobile`
  contactButton = `${this.name}.contact-button`
}